<template>
  <div class="Organization wow bounceInUp">
    <div class="cont">
      <ComTitlte titleEn="ORGANIZATION" titleZh="组织架构"></ComTitlte>
      <div class="main">
        <img src="../../assets/img/company/organization.png" alt="..." />
      </div>

      <!-- <div v-for="item in organList" :key="item.imageId">
        <ComTitlte titleEn="ORGANIZATION" :titleZh="item.imageName"></ComTitlte>
        <div class="main">
          <img :src="imgBaseUrl + item.imageUrl" :alt="item.imageName" />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
export default {
  name: "Organization",
  data() {
    return {
      organList: [],
      imgBaseUrl: "",
    };
  },
  created() {
    this.getImageManageList();
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  methods: {
    async getImageManageList() {
      let organData = await this.$request.getImageManageList({
        columnType: "54",
      });
      if (organData.code == 200) {
        this.organList = organData.rows;
        this.imgBaseUrl = this.$store.state.baseUrl;
      }
    },
  },
  components: { ComTitlte },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
$themeMinWidth: 1180px;
.Organization {
  position: relative;
  z-index: 9;
}
.cont {
  width: $themeMinWidth;
  margin: 40px auto 0;
  position: relative;
  z-index: 6;
  background: #fff;
  box-sizing: border-box;
  padding: 10px 20px 40px 20px;
  border: solid 1px #e3e3e3;
  &::before {
    content: "";
    display: block;
    width: 33px;
    height: 15px;
    background: url("../../assets/img/common/icon_sanjiao.png") top center
      no-repeat;
    background-size: cover;
    position: absolute;
    top: -13px;
    left: 440px;
    z-index: 66;
  }
  .main {
    padding: 50px 0 0 0;
    img {
      display: block;
      margin: 0 auto;
    }
    p {
      font-size: 16px;
      line-height: 30px;
      color: #666666;
      text-align: justify;
      text-indent: 32px;
    }
  }
}
</style>
